import React, { useEffect, useRef } from "react";
import CustomLoader from "../Loader";
import { Modal } from "bootstrap";

const CommonModal = ({
  modalId,
  title,
  loader,
  bodyContent,
  footerContent,
  handleCloseIcon,
  showCloseIcon = true,
  closeModalTrigger = false,
  modalSize = "modal-md",
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const modalElement = modalRef.current;

    // Always create modal on mount (but don’t show it)
    if (modalElement && !Modal.getInstance(modalElement)) {
      new Modal(modalElement);
    }
  }, []);

  useEffect(() => {
    if (closeModalTrigger) {
      const modalElement = modalRef.current;
      if (modalElement) {
        const modalInstance =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modalInstance.hide();
      }
    }
  }, [closeModalTrigger]);

  return (
    <>
      <div
        className="modal fade"
        id={modalId}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        ref={modalRef}
      >
        {/* <div className="modal-dialog modal-xl"> */}
        <div className={`modal-dialog ${modalSize}`}>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{title}</h4>
              {showCloseIcon && (
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-hidden="true"
                  onClick={handleCloseIcon}
                ></button>
              )}
            </div>
            <div className="modal-body">
              {loader ? <CustomLoader /> : bodyContent}
            </div>
            <div className="modal-footer">
              {
                footerContent
                // || (
                //   <a href="#/" className="btn btn-white" data-bs-dismiss="modal">
                //     Close
                //   </a>
                // )
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonModal;
